// 应用全局状态模块
const state = {
  // 侧边栏是否折叠（默认收起）
  sidebarCollapsed: true,
  // 当前设备类型：desktop/tablet/mobile
  deviceType: 'desktop',
  // 页面加载状态
  loading: false
}

const mutations = {
  // 切换侧边栏折叠状态
  TOGGLE_SIDEBAR(state) {
    state.sidebarCollapsed = !state.sidebarCollapsed
  },
  // 设置侧边栏折叠状态
  SET_SIDEBAR_COLLAPSED(state, collapsed) {
    state.sidebarCollapsed = collapsed
  },
  // 设置设备类型
  SET_DEVICE_TYPE(state, deviceType) {
    state.deviceType = deviceType
  },
  // 设置加载状态
  SET_LOADING(state, loading) {
    state.loading = loading
  }
}

const actions = {
  // 切换侧边栏
  toggleSidebar({ commit }) {
    commit('TOGGLE_SIDEBAR')
  },
  // 设置加载状态
  setLoading({ commit }, loading) {
    commit('SET_LOADING', loading)
  }
}

const getters = {
  isMobile: state => state.deviceType === 'mobile'
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
